export default {
  bookExperiencePanel: 'Book experience panel',
  calendarIcon: 'Calendar icon',
  coverImageForResource: 'Cover image for {{title}} experiences',
  filterBy: 'Filter by {{filter}}',
  filterByDateRange: 'Filter by date range',
  gallery: 'Gallery',
  goBack: 'Back to previous page',
  hostUserIcon: 'host user icon',
  imageOf: 'Image of {{title}}',
  interactiveMapAltText: 'Interactive map with selectable {{title}}',
  mediaSlides: 'Media slides',
  muteVideo: 'Mute video',
  nextPhoto: 'Next photo',
  noVideoPlayback: 'No video playback capacity',
  pauseVideo: 'Pause video',
  photoOf: 'photo of {{name}}',
  playVideo: 'Play video',
  previousPhoto: 'Previous photo',
  moreFiltersAndExperiences: 'More filters and experiences',
  reserveSelectedSlot: 'Reserve selected slot',
  reviewRating: 'Review rating {{rating}} of 5',
  overallReviewRating: 'Overall review rating {{rating}} of 5',
  selectCountryCodeForPhoneNumber: 'Select country code for phone number',
  selectDate: 'Select date',
  selectParticipants: 'Select participants',
  selectSessionTime: 'Select session time',
  unmuteVideo: 'Unmute video',
  viewShoppingCart: 'View shopping cart',
  itemsInCart: '{{count}} items in shopping cart',
  zoomIn: 'Zoom in',
  zoomOut: 'Zoom out',
  selectData: `Select {{data}}`,
  reserveName: `Reserve {{name}}`,
  deleteReservation: 'Delete {{experienceTitle}} reservation',
  editParticipantsFor: 'Edit participants for {{experienceTitle}}',
  enterPromoCode: 'Enter promo code',
  applyPromoCode: 'Apply promo code',
  increaseAddOnAmount: 'Increase {{addOn}} selected',
  decreaseAddOnAmount: 'Decrease {{addOn}} selected',
  addOnModal: '{{addOn}} modal',
  moreInformationAboutAddOn: 'More information about {{addOn}}',
  decreasePriceTierTickets: 'Decrease {{priceTier}} tickets',
  increasePriceTierTickets: 'Increase {{priceTier}} tickets',
  downloadFilename: 'Download {{filename}}',
  viewFullDetailsDescription: 'View full details description',
  viewFullDescription: 'View full description',
  closeModal: 'Close modal',
  hyattBanner: 'World Of Hyatt Member Exclusive Banner',
  hyattBannerDesc:
    'Promotional banner indicating exclusive benefits and offers available to World of Hyatt loyalty program members',
  previousSlide: 'Previous slide',
  nextSlide: 'Next slide',
  paginationBulletMessage: 'Go to slide',
  exitFullscreen: 'Exit fullscreen view',
  enterFullscreen: 'Enter fullscreen view',
  videoSlide: 'Video slide',
  imageSlide: 'Image slide',
  of: 'of',
  noDescription: 'No description',
  mediaGallery: 'Carousel - Media gallery',
  dateSelector: 'Date selector',
  nextWeek: 'Next week',
  previousWeek: 'Previous week',
  scheduleAgenda: 'Schedule agenda',
  scheduleNav: 'Schedule navigation',
  scheduleViewSelector: 'Schedule view selector',
  selectedDateAriaLabel: '{{date}}, selected',
  tapToBookExperience: 'Book {{title}}',
  bookExperienceAriaLabel: 'Book {{title}}',
  joinWaitlistAriaLabel: 'Join waitlist for {{title}}',
};
